import { atom } from 'jotai';

export const shouldOpenAtStep2Atom = atom<boolean>(false);
